// import '~/src/styles/theme.scss'

import { createApp } from 'vue'
import VueScrollTo from 'vue-scrollto'
import { Portal } from 'portal-vue'

import PageAccountActivate from '../components/page/PageAccountActivate.vue'
import PageAccountAddresses from '../components/page/PageAccountAddresses.vue'
import PageAccountDashboard from '../components/page/PageAccountDashboard.vue'
import PageAccountLogin from '../components/page/PageAccountLogin.vue'
import PageAccountOrder from '../components/page/PageAccountOrder.vue'
import PageAccountRegister from '../components/page/PageAccountRegister.vue'
import PageAccountReset from '../components/page/PageAccountReset.vue'
import PageArticleLookbook from '../components/page/PageArticleLookbook.vue'
import PageBlogLookbooks from '../components/page/PageBlogLookbooks.vue'
import PageTemplateBlogLookbookIndex from '../components/page/PageTemplateBlogLookbookIndex.vue'
import PageTemplateBlogLookbookArticle from '../components/page/PageTemplateBlogLookbookArticle.vue'
import PageCart from '../components/page/PageCart.vue'
import PageCollection from '../components/page/PageCollection.vue'
import PageCollectionFeatured from '../components/page/PageCollectionFeatured.vue'
import PageCollectionInStock from '../components/page/PageCollectionInStock.vue'
import PageCollectionSignup from '../components/page/PageCollectionSignup.vue'
import PageCollectionColors from '../components/page/PageCollectionColors.vue'
import PageCollectionArchive from '../components/page/PageCollectionArchive.vue'

import PageError from '../components/page/PageError.vue'
import PageProduct from '../components/page/PageProduct.vue'
import PageProductNoSale from '../components/page/PageProductNoSale.vue'
import PageProductPolishSet from '../components/page/PageProductPolishSet.vue'
import PageSearch from '../components/page/PageSearch.vue'
import PageTemplateAbout from '../components/page/PageTemplateAbout.vue'
import PageTemplateContact from '../components/page/PageTemplateContact.vue'
import PageTemplateColumns from '../components/page/PageTemplateColumns.vue'
import PageTemplateCustomInquiry from '../components/page/PageTemplateCustomInquiry.vue'
import PageTemplateDefault from '../components/page/PageTemplateDefault.vue'
import PageTemplateFaq from '../components/page/PageTemplateFaq.vue'
import PageTemplatePassage from '../components/page/PageTemplatePassage.vue'
import PageTemplatePress from '../components/page/PageTemplatePress.vue'
import PageTemplatePressIndex from '../components/page/PageTemplatePressIndex.vue'
import PageTemplateShipping from '../components/page/PageTemplateShipping.vue'
import PageTemplateSignup from '../components/page/PageTemplateSignup.vue'
import PageTemplateStockists from '../components/page/PageTemplateStockists.vue'
import PageTemplateText from '../components/page/PageTemplateText.vue'

import HomeSectionColors from '../components/home/HomeSectionColors.vue'
import HomeSectionCollections from '../components/home/HomeSectionCollections.vue'
import HomeSectionFeature from '../components/home/HomeSectionFeature.vue'
import HomeSectionImage from '../components/home/HomeSectionImage.vue'
import HomeSectionLinks from '../components/home/HomeSectionLinks.vue'
import HomeSectionSlideshow from '../components/home/HomeSectionSlideshow.vue'
import HomeSectionProducts from '../components/home/HomeSectionProducts.vue'
import HomeSectionBespoke from '../components/home/HomeSectionBespoke.vue'

import LayoutDefault from '../components/layout/LayoutDefault.vue'

import HeaderDesktop from '../components/header/HeaderDesktop.vue'
import HeaderMobile from '../components/header/HeaderMobile.vue'
import FooterDefault from '../components/footer/FooterDefault.vue'

const app = createApp({
  components: {
    LayoutDefault,

    HeaderDesktop,
    HeaderMobile,
    FooterDefault,

    HomeSectionColors,
    HomeSectionCollections,
    HomeSectionFeature,
    HomeSectionImage,
    HomeSectionLinks,
    HomeSectionSlideshow,
    HomeSectionProducts,
    HomeSectionBespoke,

    PageAccountActivate,
    PageAccountAddresses,
    PageAccountDashboard,
    PageAccountLogin,
    PageAccountOrder,
    PageAccountRegister,
    PageAccountReset,

    PageArticleLookbook,
    PageBlogLookbooks,
    PageTemplateBlogLookbookIndex,
    PageTemplateBlogLookbookArticle,
    PageCart,
    PageError,
    PageProduct,
    PageProductNoSale,
    PageProductPolishSet,
    PageSearch,

    PageCollection,
    PageCollectionFeatured,
    PageCollectionInStock,
    PageCollectionSignup,
    PageCollectionColors,
    PageCollectionArchive,

    PageTemplateAbout,
    PageTemplateColumns,
    PageTemplateContact,
    PageTemplateCustomInquiry,
    PageTemplateDefault,
    PageTemplateFaq,
    PageTemplatePassage,
    PageTemplatePress,
    PageTemplatePressIndex,
    PageTemplateSignup,
    PageTemplateShipping,
    PageTemplateStockists,
    PageTemplateText,
  },

  mounted() {
    const routeScript = document.createElement('script')
    routeScript.setAttribute(
      'src',
      'https://cdn.routeapp.io/route-widget-shopify/route-widget-shopify-1.4.4.min.js?shop=jhannah-dev.myshopify.com'
    )

    // Add Recaptcha Script
    window.addEventListener('DOMContentLoaded', () => {
      const t = document.createElement('script')
      t.setAttribute(
        'src',
        `https://www.recaptcha.net/recaptcha/api.js?render=${window.Shopify?.recaptchaV3?.siteKey}&hl=en`
      ),
        document.body.appendChild(t)
    })
  },
})

// eslint-disable-next-line vue/multi-word-component-names
app.component('Portal', Portal)
app.use(VueScrollTo)

app.component('PageCollectionArchive', PageCollectionArchive)

app.mount('#app')

// --- Press Index mount helpers ---
const pressApps = new WeakMap<HTMLElement, ReturnType<typeof createApp>>()

function mountPressIndexIn(root: HTMLElement) {
  const prev = pressApps.get(root)
  if (prev) {
    try {
      prev.unmount()
    } catch {}
  }

  try {
    const blocks = JSON.parse(root.dataset.pressBlocks || '[]')
    const app = createApp(PageTemplatePressIndex, { blocks })
    app.mount(root)
    pressApps.set(root, app)
  } catch (err) {
    console.error('Error parsing press blocks JSON', err)
  }
}

function mountAllPressIndex(scope: ParentNode | Document = document) {
  scope.querySelectorAll<HTMLElement>('[id^="press-root-"]').forEach(mountPressIndexIn)
}

mountAllPressIndex()

if ((window as any).Shopify && (window as any).Shopify.designMode) {
  document.addEventListener('shopify:section:load', (e: any) => {
    const sectionId = e?.detail?.sectionId
    const container = document.getElementById(`shopify-section-${sectionId}`)
    if (container) mountAllPressIndex(container)
  })

  document.addEventListener('shopify:section:unload', (e: any) => {
    const sectionId = e?.detail?.sectionId
    const container = document.getElementById(`shopify-section-${sectionId}`)
    if (!container) return

    container.querySelectorAll<HTMLElement>('[id^="press-root-"]').forEach((root) => {
      const app = pressApps.get(root)
      if (app) {
        try {
          app.unmount()
        } catch {}
        pressApps.delete(root)
      }
    })
  })

  document.addEventListener('shopify:section:select', (e: any) => {
    const sectionId = e?.detail?.sectionId
    const container = document.getElementById(`shopify-section-${sectionId}`)
    if (container) mountAllPressIndex(container)
  })
}

// ---- About: island mount + editor-safe remounts ----
const aboutIslands = new WeakMap<HTMLElement, ReturnType<typeof createApp>>()

function mountAboutElement(el: HTMLElement) {
  const prev = aboutIslands.get(el)
  if (prev) {
    try {
      prev.unmount()
    } catch {}
  }

  try {
    const json = el.dataset.blocks || '[]'
    const blocks = JSON.parse(json)
    const app = createApp(PageTemplateAbout, { blocks })
    app.mount(el)
    aboutIslands.set(el, app)
  } catch (e) {
    console.error('[About] Failed to parse/mount blocks:', e)
  }
}

function mountAllAbout(scope: ParentNode | Document = document) {
  scope.querySelectorAll<HTMLElement>('page-template-about').forEach(mountAboutElement)
}

mountAllAbout()

if ((window as any).Shopify?.designMode) {
  document.addEventListener('shopify:section:load', (e: any) => {
    const id = e?.detail?.sectionId
    const container = document.getElementById(`shopify-section-${id}`)
    if (container) mountAllAbout(container)
  })

  document.addEventListener('shopify:section:unload', (e: any) => {
    const id = e?.detail?.sectionId
    const container = document.getElementById(`shopify-section-${id}`)
    if (!container) return
    container.querySelectorAll<HTMLElement>('page-template-about').forEach((el) => {
      const app = aboutIslands.get(el)
      if (app) {
        try {
          app.unmount()
        } catch {}
        aboutIslands.delete(el)
      }
    })
  })

  document.addEventListener('shopify:section:select', (e: any) => {
    const id = e?.detail?.sectionId
    const container = document.getElementById(`shopify-section-${id}`)
    if (container) mountAllAbout(container)
  })
}

// ---- Contact: island mount + editor-safe remounts ----
const contactIslands = new WeakMap<HTMLElement, ReturnType<typeof createApp>>()

function mountContactElement(el: HTMLElement) {
  const prev = contactIslands.get(el)
  if (prev) {
    try {
      prev.unmount()
    } catch {}
  }

  try {
    const json = el.dataset.blocks || '[]'
    const blocks = JSON.parse(json)
    const app = createApp(PageTemplateContact, { blocks })
    app.mount(el)
    contactIslands.set(el, app)
  } catch (e) {
    console.error('[Contact] Failed to parse/mount blocks:', e)
  }
}

function mountAllContact(scope: ParentNode | Document = document) {
  scope
    .querySelectorAll<HTMLElement>('.page-template-contact[data-blocks]')
    .forEach(mountContactElement)
}

mountAllContact()

if ((window as any).Shopify?.designMode) {
  document.addEventListener('shopify:section:load', (e: any) => {
    const id = e?.detail?.sectionId
    const container = document.getElementById(`shopify-section-${id}`)
    if (container) mountAllContact(container)
  })

  document.addEventListener('shopify:section:unload', (e: any) => {
    const id = e?.detail?.sectionId
    const container = document.getElementById(`shopify-section-${id}`)
    if (!container) return
    container.querySelectorAll<HTMLElement>('.page-template-contact[data-blocks]').forEach((el) => {
      const app = contactIslands.get(el)
      if (app) {
        try {
          app.unmount()
        } catch {}
        contactIslands.delete(el)
      }
    })
  })

  document.addEventListener('shopify:section:select', (e: any) => {
    const id = e?.detail?.sectionId
    const container = document.getElementById(`shopify-section-${id}`)
    if (container) mountAllContact(container)
  })
}

// ---- Custom Inquiry: island mount + editor-safe remounts ----
const customInquiryIslands = new WeakMap<HTMLElement, ReturnType<typeof createApp>>()

function mountCustomInquiryElement(el: HTMLElement) {
  const prev = customInquiryIslands.get(el)
  if (prev) {
    try {
      prev.unmount()
    } catch {}
  }

  try {
    const app = createApp(PageTemplateCustomInquiry)
    app.mount(el)
    customInquiryIslands.set(el, app)
  } catch (e) {
    console.error('[Custom Inquiry] Failed to mount:', e)
  }
}

function mountAllCustomInquiry(scope: ParentNode | Document = document) {
  scope.querySelectorAll<HTMLElement>('page-template-custom-inquiry').forEach(mountCustomInquiryElement)
}

mountAllCustomInquiry()

if ((window as any).Shopify?.designMode) {
  document.addEventListener('shopify:section:load', (e: any) => {
    const id = e?.detail?.sectionId
    const container = document.getElementById(`shopify-section-${id}`)
    if (container) mountAllCustomInquiry(container)
  })

  document.addEventListener('shopify:section:unload', (e: any) => {
    const id = e?.detail?.sectionId
    const container = document.getElementById(`shopify-section-${id}`)
    if (!container) return

    container.querySelectorAll<HTMLElement>('page-template-custom-inquiry').forEach((el) => {
      const app = customInquiryIslands.get(el)
      if (app) {
        try {
          app.unmount()
        } catch {}
        customInquiryIslands.delete(el)
      }
    })
  })
}

// ---- Shipping: island mount + editor-safe remounts ----
const shippingIslands = new WeakMap<HTMLElement, ReturnType<typeof createApp>>()

function mountShippingElement(el: HTMLElement) {
  const prev = shippingIslands.get(el)
  if (prev) {
    try {
      prev.unmount()
    } catch {}
  }

  try {
    const blocks = JSON.parse(el.dataset.blocks || '[]')
    const app = createApp(PageTemplateShipping, { blocks })
    app.mount(el)
    shippingIslands.set(el, app)
  } catch (e) {
    console.error('[Shipping] Failed to parse/mount blocks:', e)
  }
}

function mountAllShipping(scope: ParentNode | Document = document) {
  scope
    .querySelectorAll<HTMLElement>('.page-template-shipping[data-blocks]')
    .forEach(mountShippingElement)
}

mountAllShipping()

if ((window as any).Shopify?.designMode) {
  document.addEventListener('shopify:section:load', (e: any) => {
    const id = e?.detail?.sectionId
    const container = document.getElementById(`shopify-section-${id}`)
    if (container) mountAllShipping(container)
  })

  document.addEventListener('shopify:section:unload', (e: any) => {
    const id = e?.detail?.sectionId
    const container = document.getElementById(`shopify-section-${id}`)
    if (!container) return

    container.querySelectorAll<HTMLElement>('.page-template-shipping[data-blocks]').forEach((el) => {
      const app = shippingIslands.get(el)
      if (app) {
        try {
          app.unmount()
        } catch {}
        shippingIslands.delete(el)
      }
    })
  })

  document.addEventListener('shopify:section:select', (e: any) => {
    const id = e?.detail?.sectionId
    const container = document.getElementById(`shopify-section-${id}`)
    if (container) mountAllShipping(container)
  })
}
